module.exports = __webpack_public_path__ + "static/media/WEB_55.b7749924.png";